import React from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import Container from './container'

export default function DevopsOtimize() {
  const { openModal } = useModal()
  return (
    <section className="bg-[#040116] text-white">
      <Container className="py-12 flex flex-col items-center justify-center">
        <h2 className="font-inter-regular text-2xl md:text-[40px] text-center mb-8">
          Com{' '}
          <span className="font-inter-bold italic bg-gradient-to-r from-[#FC0021] to-[#4B3BDB] bg-clip-text text-transparent relative">
            DevOps
          </span>
          , integramos desenvolvimento e operações e automatizamos processos
          para entregas efetivas, ágeis e confiáveis com ainda mais qualidade.
        </h2>
      </Container>
      <div className="flex justify-center pb-8">
        <button
          type="button"
          onClick={() => openModal(<FormularioRD />)}
          className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] text-[#040116] px-8 py-3 rounded-full font-inter-medium hover:scale-105 transition-transform duration-300 ease-in-out text-lg md:text-xl cursor-pointer"
        >
          Otimize seu negócio
        </button>
      </div>
    </section>
  )
}
